// Mirrors ospra-api-service/src/constants/org-types.ts - keep in sync

export const ORG_TYPES = {
  // Tier 0 - Upstream (reserved, not active yet)
  RAW_MATERIAL_SUPPLIER: "raw_material_supplier",
  IMPORTER_DISTRIBUTOR: "importer_distributor",

  // Tier 1 - Manufacturing
  CELL_MANUFACTURER: "cell_manufacturer",
  BATTERY_PACK_MANUFACTURER: "battery_pack_manufacturer",
  INTEGRATED_MANUFACTURER: "integrated_manufacturer",

  // Tier 2 - Integration & Deployment
  EV_OEM: "ev_oem",
  ESS_INTEGRATOR: "ess_integrator",

  // Tier 3 - Operation & Lifecycle
  FLEET_OPERATOR: "fleet_operator",
  SERVICE_PROVIDER: "service_provider",

  // Tier 4 - End-of-Life
  RECYCLER: "recycler",
  REFURBISHER: "refurbisher",
  RECYCLER_REFURBISHER: "recycler_refurbisher",

  // Tier 5 - Oversight
  REGULATORY_BODY: "regulatory_body",
  CERTIFICATION_LAB: "certification_lab",

  // Legacy
  PARTNER: "partner",
} as const;

export type OrgType = (typeof ORG_TYPES)[keyof typeof ORG_TYPES];

// RBAC helper sets - mirror backend groups exactly
export const CELL_MFR_TYPES: OrgType[] = [
  "cell_manufacturer",
  "integrated_manufacturer",
];
export const BATTERY_MFR_TYPES: OrgType[] = [
  "battery_pack_manufacturer",
  "integrated_manufacturer",
];
export const ALL_MFR_TYPES: OrgType[] = [
  "cell_manufacturer",
  "battery_pack_manufacturer",
  "integrated_manufacturer",
];
export const INTEGRATION_TYPES: OrgType[] = ["ev_oem", "ess_integrator"];
export const OPERATIONS_TYPES: OrgType[] = [
  "fleet_operator",
  "service_provider",
];
export const EOL_TYPES: OrgType[] = [
  "recycler",
  "refurbisher",
  "recycler_refurbisher",
];
export const REFURBISHER_TYPES: OrgType[] = [
  "refurbisher",
  "recycler_refurbisher",
];
export const RECYCLER_TYPES: OrgType[] = ["recycler", "recycler_refurbisher"];
export const OVERSIGHT_TYPES: OrgType[] = [
  "regulatory_body",
  "certification_lab",
];
export const WRITE_CAPABLE_TYPES: OrgType[] = [
  ...ALL_MFR_TYPES,
  ...INTEGRATION_TYPES,
  ...OPERATIONS_TYPES,
  ...EOL_TYPES,
  "partner",
];
export const EPR_ELIGIBLE_TYPES: OrgType[] = [
  "battery_pack_manufacturer",
  "integrated_manufacturer",
  "ev_oem",
  "recycler",
  "refurbisher",
  "recycler_refurbisher",
];
